import { colors } from '@ui/colors'
import Glass from '@ui/elements/Glass'
import { Platform, StyleProp, ViewStyle } from 'react-native'

interface Props {
  children: React.ReactNode
  style?: StyleProp<ViewStyle>
}

export default function GlassButton({ children, style = {} }: Props) {
  const size = 48
  return (
    <Glass
      tint="prominent"
      blur={Platform.select({ default: 40, web: 100 })}
      border={{ borderColor: 'transparent', borderRadius: size }}
      style={[
        {
          width: size,
          height: size,
          alignItems: 'center',
          justifyContent: 'center',
        },
        style,
      ]}
      gradient={[colors.white0, colors.white0]}
    >
      {children}
    </Glass>
  )
}
